import { graphql, Link } from "gatsby";
import PropTypes from "prop-types";
import React from "react";
import Footer from "../components/footer";
import Header from "../components/header";
import SEO from "../components/seo";
import ServersSection from "../containers/servers";
import "../styles/home.css";

const IndexPage = ({ location, data }) => {
    const serverData = data.allMdx.nodes;

    return (
        <main>
            <SEO location={location} />
            <Header />

            <ServersSection servers={serverData} background={data.serversBackground} />

            <div className="download" id="download">
                <h1>MineYourMind Launcher</h1>
                <h2>play.mineyourmind.net</h2>

                <div className="download-buttons">
                    <a href="https://update.mym.li/launcher/MyM-Launcher.exe">
                        <button>Windows</button>
                    </a>
                    <a href="https://update.mym.li/launcher/MyM-Launcher.jar">
                        <button>Mac/Linux</button>
                    </a>
                </div>

                <p>
                    If you have any problems with the launcher please check out our&nbsp;
                    <Link to="/wiki/launcher/issues/">common issues</Link> page.
                </p>
                <p>
                    Don&apos;t want to use our launcher? <Link to="/join-us">Server IP and further instructions</Link>.
                </p>
            </div>

            <Footer />
        </main>
    );
};

export const query = graphql`
    query IndexPageQuery {
        allMdx(
            filter: { fields: { collection: { eq: "server" } }, frontmatter: { archived: { ne: true } } }
            sort: { frontmatter: { name: ASC } }
        ) {
            nodes {
                fields {
                    slug
                }
                frontmatter {
                    name
                    order
                }
                icon {
                    childImageSharp {
                        gatsbyImageData(height: 64, width: 64, layout: FIXED)
                        # gatsbyImageData(
                        #     sizes: "(min-width: 1000px) 64px, (min-width: 900px) 48px, 32px"
                        #     breakpoints: [32, 48, 64]
                        #     width: 64
                        #     height: 64
                        # )
                    }
                }
            }
        }
        serversBackground: file(relativePath: { eq: "images/servers-section-background.jpg" }) {
            childImageSharp {
                gatsbyImageData(layout: FULL_WIDTH, breakpoints: [1366, 1920, 2560], placeholder: BLURRED)
            }
        }
    }
`;

IndexPage.propTypes = {
    location: PropTypes.shape({}),
    data: PropTypes.shape({
        allMdx: PropTypes.shape({
            nodes: PropTypes.arrayOf(PropTypes.shape({})),
        }),
        serversBackground: PropTypes.object,
    }),
};

export default IndexPage;
